/**
 * Copyright 2023-2024 Highway9 Networks Inc.
 */
import { Icons } from "../components/GraphicalResources";
import { text } from "../components/TextResources";

export const VMC_URL = "/"
export const DASHBOARD = "/dashboard";
export const LOGIN = "/login";
export const EDGES = "/edges";
export const RADIOS = "/radios";
export const DEVICES = "/devices";
export const NETWORKS = "/networks";
export const VMZ = "/vmz";
export const SIMULATORS = "/simulators";
export const SETTINGS = "/settings";
export const PROFILES = "/profiles";
export const AUDITLOGS = "/auditlogs";
export const HARDWARE_INVENTORY = "/hardwareInventory";
export const API_DOCS = "/api/v1/orch/docs";
export const LICENSE_AGREEMENT = "/eula";
export const IT_DASHBOARD = "/monitor";
export const ONBOARDING = "/onboarding";
export const CREATE_SITE = "/onboarding/createSite";
export const CREATE_VMZ = "/onboarding/createVmz";
export const CREATE_VMZ_GROUP = "/onboarding/createVmzGroup";
export const CREATE_RADIO_GROUP = "/onboarding/createRadioGroup";
export const CREATE_APPLICATION = "/onboarding/createApplication";
export const CREATE_DEVICE_GROUP = "/onboarding/createDeviceGroup";
export const DEVICE_ADMINISTRATION = "/onboarding/deviceAdministration";
export const CREATE_NETWORK = "/onboarding/createNetwork";
export const DEPLOY_EDGE = "/onboarding/deployEdge";
export const CONNECT_NETWORKS_TO_EDGE = "/onboarding/connectNetworksToEdge";

export const routes = [
  { name: text.dashboard, path: DASHBOARD, icon: Icons.dashboard },
  { name: text.monitor, path: IT_DASHBOARD, icon: Icons.monitor, objectType: ["itAdminDashboard"] },
  { name: "|", path: null },
  { name: text.edge, path: EDGES, icon: <Icons.edge/>, objectType: ["edge", "dnn"] },
  { name: text.RAN, path: RADIOS, icon: Icons.OutdoorRadio, objectType: ["radio"] },
  { name: text.subscribers, path: DEVICES, icon: Icons.subscribers, objectType: ["device"] },
  { name: "|", path: null },
  { name: text.DNN, path: NETWORKS, icon: Icons.APN_DNN, objectType: ["dnn"] },
  { name: text.VMZ, path: VMZ, icon: Icons.VMZ, objectType: ["zone"] },
  { name: text.Profiles, path: PROFILES, icon: Icons.profiles, objectType: ["mobilityProfile", "systemSettings"] },
  { name: "|", path: null },
  { name: text.simulators, path: SIMULATORS, icon: Icons.simulators, objectType: ["simulator"] },
  { name: "|", path: null },
  { name: text.administration, path: SETTINGS, icon: Icons.settings, objectType: ["network"] },
  { name: text.auditLog, path: AUDITLOGS, icon: Icons.logs, objectType: ["log"] },
  { name: text.hardwareInventory, path: HARDWARE_INVENTORY, icon: Icons.hardwareInventory, objectType: ["vmcHardware"] },
  { name: "|", path: null },
  { name: text.onboarding?.title, path: ONBOARDING, icon: <Icons.EmergencyIcon color="#ffffff" size={20} /> },
];

export const bottomRoutes = [{ name: text.apiDocs, path: API_DOCS, icon: Icons.apiDocs }];

export const NEW_ROUTES = [DASHBOARD, LOGIN, IT_DASHBOARD];

export const profileCardRoutes = [
  { name: text.apiDocs, path: API_DOCS, icon: Icons.apiDocs },
  // { name: text.licenseAgreement, path: LICENSE_AGREEMENT, icon: Icons.license },
];


export const TAB_NAMES = {
  SUMMARY: "Summary",
  AUDIT_LOG: "Audit_Log",
  EVENTS: "Events",
  NOTES: "Notes",
} as const;

export const RADIO_TAB_NAMES = {
  ...TAB_NAMES,
  METRICS: "Metrics",
  ALARMS: "Alarms",
  NEIGHBORS_LIST: "NeighborsList",
  CONNECTED_DEVICES: "ConnectedDevices",
  SAS_LOGS: "SasLogs",
  INSIGHTS: "Insights",
  FLOOR_PLAN: "FloorPlan",
} as const;

export const EDGE_TAB_NAMES = {
  ...TAB_NAMES,
  INSIGHTS: "Insights",
} as const;

export const CARRIER_GATEWAY_TAB_NAMES = {
  ...TAB_NAMES,
  METRICS: "Metrics",
  INSIGHTS: "Insights",
  OPERATOR_DETAILS: "OperatorDetails",
  CONNECTED_EDGE_DEVICES: "ConnectedEdgeDevices",
  CONNECTED_RADIOS: "ConnectedRadios",
  LOGS: "Logs",
} as const;


export const SUBSCRIBER_TAB_NAMES = {
  ...TAB_NAMES,
  METRICS: "Metrics",
  LOGS: "Logs",
  FLOWS: "Flows",
  INSIGHTS: "Insights",

  SIMULATION: "Simulation",
} as const;
